import { gql } from "@apollo/client";
import { ActiveContext } from "shared/ContextSwitcher/ActiveContext";
import { useSession } from "src/components/session/session";
import {
  useGetTeamStorageUsageQuery,
  useGetUserStorageQuery,
} from "src/gql/codegen/graphql";
import { isDefined } from "src/utils/types/types";

export const useStorageUsage = (activeContext: ActiveContext | undefined) => {
  const session = useSession();

  const { data: userData, loading: userLoading } = useGetUserStorageQuery({
    skip: !session?.user || activeContext?.type !== "user",
    context: { session },
    fetchPolicy: "cache-first",
  });

  const { data: teamData, loading: teamLoading } = useGetTeamStorageUsageQuery({
    skip: !session?.user || activeContext?.type !== "team",
    context: { session },
    variables: {
      teamId: activeContext?.id ?? -1,
    },
    fetchPolicy: "cache-first",
  });

  const { bytes_allowed = 0, bytes_used = 0 } =
    (userData ?? teamData)?.billable_usage ?? {};

  return {
    isLoading: userLoading || teamLoading,
    isStorageLimitReached:
      isDefined(bytes_allowed) &&
      isDefined(bytes_used) &&
      bytes_used > bytes_allowed,
    bytesAllowed: bytes_allowed,
    bytesUsed: bytes_used,
  };
};

gql`
  query GetUserStorage {
    billable_usage {
      bytes_used
      bytes_allowed
    }
  }
`;

gql`
  query GetTeamStorageUsage($teamId: Int!) {
    billable_usage: team_billable_usage(team_id: $teamId) {
      bytes_used
      bytes_allowed
    }
  }
`;
